'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { cn } from '../../utils/cn';
import { UploadContext } from './UploadContext';
const Upload = forwardRef(({ children, className, options, horizontal, ...props }, ref) => {
    const ContextValue = useMemo(() => ({ options, horizontal }), [options, horizontal]);
    return (_jsx("div", { ref: ref, ...props, className: cn('max-w-full rounded-xl border border-dashed border-metal-100 bg-white p-6 dark:border-metal-800 dark:bg-metal-900 ', className), children: _jsx(UploadContext.Provider, { value: ContextValue, children: children }) }));
});
Upload.displayName = 'Upload';
export { Upload };
